import React from 'react'
import classNames from 'classnames'
import css from './Page.css'
type Props = {
  children: any
  className?: string
}

const Page = ({ children, className }: Props) => (
  <div className={classNames([css.component, className])}>{children}</div>
)

export default Page
